class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
    this.summaryLink = this.querySelector(`summary > a`);

    if (this.summaryLink) {
      this.summaryLink.addEventListener('click', this.onSummaryLinkClick.bind(this))
      this.summaryLink.addEventListener('keydown', (event) => {
        if(event.key !== 'Enter' && event.key !== ' ') { return; }

        this.onSummaryLinkClick(event);
      })
    }
  }

  onSummaryLinkClick(event) {
    event.stopPropagation();
    event.preventDefault();
    window.location.href = event.currentTarget.href;
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

    const configs = [
      {
        topLevelSelector: '.header__inline-menu details[class="mega-menu"]',
        contentSelector: '.mega-menu__content',
      },
      {
        topLevelSelector: '.account-dropdown__container details[class="dropdown"]',
        contentSelector: `.list-menu--disclosure`,
      }
    ];

    configs.forEach((config) => {
      // open on hover
      const topLevelItems = this.querySelectorAll(config.topLevelSelector);
      topLevelItems.forEach(topLevelItem => {
        topLevelItem.addEventListener("mouseenter", function() {
          // setTimeout is required to work with <details /> native behavior
          setTimeout(() => {
            topLevelItem.setAttribute("open", '');
          }, 1);
        });

        const expandedContent = topLevelItem.querySelector(config.contentSelector);
        if (expandedContent) {
          expandedContent.addEventListener("mouseleave", () => {
            // setTimeout is required to work with <details /> native behavior
            setTimeout(() => {
              if (topLevelItem.matches(':hover')) { return; }

              topLevelItem.removeAttribute("open");
            }, 1);
          });
        }

        topLevelItem.addEventListener("mouseleave", () => {
          // setTimeout is required to work with <details /> native behavior
          setTimeout(() => {
              if (expandedContent.matches(':hover')) { return; }

            topLevelItem.removeAttribute("open");
          }, 1);
        });
      });
    });
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
